export const UserTypeEnum = Object.freeze({
  PATIENT: 'patient',
});

export const EmailTemplateEnum = Object.freeze({
  WELCOME: 'welcome',
});

export const STEPS = Object.freeze({
  CONFIRMATION: 'confirmation',
  OPTIONS: 'options',
});

export const STEP_TITLES = Object.freeze({
  [STEPS.CONFIRMATION]: 'Set Patient Password',
  [STEPS.OPTIONS]: 'Choose Password Set Method',
});
